import { sanitizeHtml, splitEmailContent } from '../../lib/inbox/email-html';
import { CollapsibleQuote } from './CollapsibleQuote';

/**
 * Render een email body: gesanitized HTML met geciteerde tekst inklapbaar.
 * Fallback naar plain-text als HTML niet beschikbaar is.
 *
 * Geëxtraheerd uit InboxThreadPage.tsx in batch D sub-stap 9a.
 */
export function EmailBody({ html, text }: { html: string | null; text: string | null }) {
  if (!html) {
    return (
      <p className="text-sm text-slate-700 whitespace-pre-wrap">
        {text || '(Geen inhoud)'}
      </p>
    );
  }

  // Inline bijlagen (src="cid:...") kan de browser niet laden en staan als
  // kapot icoon in de mail; de AttachmentList onder het bericht toont ze wel.
  const sanitized = sanitizeHtml(html).replace(/<img\b[^>]*\bsrc=["']cid:[^"']*["'][^>]*>/gi, '');
  const { body, quoted } = splitEmailContent(sanitized);

  return (
    <div>
      <div
        className="text-sm text-slate-700 prose prose-sm max-w-none prose-p:my-1 prose-headings:my-2 prose-a:text-indigo-600 prose-a:underline prose-img:max-w-full prose-img:h-auto"
        dangerouslySetInnerHTML={{ __html: body }}
      />
      {quoted && <CollapsibleQuote html={quoted} />}
    </div>
  );
}
